// extracted by mini-css-extract-plugin
export default {"ctn":"styles_ctn__pj+t-","error":"styles_error__5rKMk"};